import { Container } from '@chakra-ui/react';
import HomeLayout from '../../../components/layouts/homelayout';

import CarouselSimple from '../../../components/sections/carouselsimple';

import japanCard from '../../../components/ui/regionalcareers/asia/japan.jpg'
import chinaCard from '../../../components/ui/regionalcareers/asia/CHINA-1.jpg'
import koreaCard from '../../../components/ui/regionalcareers/asia/KOREA-7.jpg'
import hkCard from '../../../components/ui/regionalcareers/asia/Hong_Kong.jpg'
import bangladeshCard from '../../../components/ui/regionalcareers/asia/BANGLADESH-1.jpg' 
import indonesiaCard from '../../../components/ui/regionalcareers/asia/INDONESIA-1.jpg'
import vietnamCard from '../../../components/ui/regionalcareers/asia/VIETNAM-2.jpg'
import indiaCard from '../../../components/ui/regionalcareers/asia/INDIA.jpg'

// Updated images
import apacHeaderImg from '../../../components/ui/regionalcareers/apac/office_entry.jpg';
import chinaRetailImg from '../../../components/ui/regionalcareers/apac/retail_Guangzhou.jpg';
import vietnamEventImg from '../../../components/ui/regionalcareers/apac/vietnam.png';
import apacOffice1Img from '../../../components/ui/regionalcareers/apac/apac_office_1.jpg';
import donuganTeamImg from '../../../components/ui/regionalcareers/apac/donnugan_team.jpg';
import teamSixImg from '../../../components/ui/regionalcareers/apac/Team6_16x9.jpg';
import teamOnRocksImg from '../../../components/ui/regionalcareers/apac/team_on_rocks.jpg';

export default function AsiaTabPanel() {

        const regionaljobs = [{
            id: 1,
            heading: 'Bangladesh',
            image: `${bangladeshCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationCountry=db69b9fc446c11de98360015c5e6daf6'
        },
        {
            id: 2,
            heading: 'India',
            image: `${indiaCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationCountry=c4f78be1a8f14da0ab49ce1162348a5e'
        },
        {
            id: 3,
            heading: 'China',
            image: `${chinaCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationCountry=6cb77610a8a543aea2d6bc10457e35d4'
        },

        {
            id: 4,
            heading: 'Japan',
            image: `${japanCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationCountry=8b705da2becf43cfaccc091da0988ab2'
        },
        {
            id: 5,
            heading: 'South Korea',
            image: `${koreaCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationCountry=7a5a2aadf9d34086a2bfbfd408bc28da'
        },
        {
            id: 6,
            heading: 'Taipei City',
            image: `${hkCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationRegionStateProvince=c5684b475b7345d0839454b2a03c5d2d'
        },
        {
            id: 7,
            heading: 'Vietnam',
            image: `${vietnamCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationCountry=db69e8c8446c11de98360015c5e6daf6'
        },
        {
            id: 8,
            heading: 'Indonesia',
            image: `${indonesiaCard}`,
            url: 'https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/CSC_Careers?source_id=csccom&source_p=careers_ap&locationCountry=b31234dbcdda4da9ba8fa073c5944e36'
        },
        ];

  return (
    <HomeLayout>
        <title>Careers in Asia Pacific - Columbia Sportswear Company</title>
        <meta name="description" content="Find your next job in our Asia Pacific locations." />

        <Container maxW={{base: 'max', lg: "1440px" }} mt={'var(--space-2xl)'} className='flow' >
            <section className="divided-hero page-banner">
                <div className="dh__feature">
                    <div className='flow'>
                        <h1>APAC Region</h1>
                        <p>Join Columbia Sportswear’s dynamic team across the Asia Pacific, where we operate in 12 countries with 15 regional offices and over 200 retail stores. Our strong presence in markets like China, Japan, South Korea, and India reflects our commitment to innovation, collaboration, and growth. With a rich heritage and a culture that values cross-functional teamwork, Columbia offers exciting career paths and professional development opportunities. Discover how you can grow your career with us in one of the world’s most diverse regions.</p>
                    </div>
                    <div>
                        <img src={apacHeaderImg} alt='' />
                    </div>
                </div>
            </section>
        </Container>

        <section className='life-in-apac'>
            <Container maxW={{base: 'max', lg: "1440px" }} mt={'var(--space-2xl)'} className='flow' css={{'--flow-space': 'var(--space-m)'}}>
                <h2>Regional Offices</h2>
                <p>From the bustling streets of Tokyo to the vibrant energy of Seoul and the dynamic spirit of Shanghai, Columbia Sportswear leads its Asia Pacific journey from three regional hubs—fueling outdoor innovation, exploration, and growth across 12 countries.</p>
                <CarouselSimple cards={regionaljobs}></CarouselSimple>

            </Container>
        </section>

        <section className='apac-retail'>
            <div className='hero-main height-100 page-banner'>
                <div className='hero-main__container'>
                <div className='hero-main__inner-container'>
                    <div className='hero-main__inner center-left is-top is-left'>
                    <div className='container'>
                        <div className='hero-main__content m-width-80'>
                            <h2>Retail</h2>
                            <p>With retail locations across the Asia Pacific region, our Columbia boutiques and stores are where adventure begins. From vibrant city centers to iconic shopping destinations, our retail teams will offer more than just products—they create unforgettable experiences. </p>
                        </div>
                    </div>
                    </div>
                    <div className='hero-main__video-container'>
                        <img src={chinaRetailImg} alt='' />
                    </div>
                    <div className='hero-main__overlay'></div>
                </div>
                </div>
            </div>
            
        </section>

        <section className='life-in-apac'>
            <Container maxW={{base: 'max', lg: "1440px" }} mt={'var(--space-2xl)'} className='flow' css={{'--flow-space': 'var(--space-m)'}}>
                <h2>Life in APAC</h2>

                <div className='image-grid'>
                    <div className='image-grid__container'>
                        <img src={vietnamEventImg} alt='A group after a successful event' />
                    </div>
                    <div className='image-grid__container'>
                        <img src={donuganTeamImg} alt='A group posing' />
                    </div>
                    <div className='image-grid__container'>
                        <img src={apacOffice1Img} alt='A group posing' />
                    </div>
                    <div className='image-grid__container'>
                        <img src={teamSixImg} alt='A team posing on stairs' />
                    </div>
                    <div className='image-grid__container'>
                        <img src={teamOnRocksImg} alt='A team posing on rocks' />
                    </div>

                </div>
            </Container>
        </section>

    </HomeLayout>
  );
}
